import IField from "@mapmycustomers/shared/types/fieldModel/IField";

import CardConfiguration, {
  DefaultDateRangeConfiguration,
} from "@app/types/dashboard/CardConfiguration";
import BasePreferences from "@app/types/dashboard/cards/BasePreferences";

import EntityTypesSupportedInEfficiencyTracker from "./EntityTypesSupportedInEfficiencyTracker";

export enum EfficiencyTrackerAggregationType {
  SUM = "SUM",
  AVG = "AVG",
}

export type EfficiencyTrackerFieldType =
  | "count"
  | "custom"
  | "facetime"
  | "newCompanies"
  | "wonRevenue";

export interface EfficiencyTrackerCriteria {
  aggregationType: EfficiencyTrackerAggregationType;
  entityType?: EntityTypesSupportedInEfficiencyTracker;
  fieldName?: IField["name"];
  fieldType: EfficiencyTrackerFieldType;
}

export default interface EfficiencyTrackerCardConfiguration extends CardConfiguration<
  EfficiencyTrackerCriteria,
  DefaultDateRangeConfiguration,
  BasePreferences
> {}
